<template>
  <div class="fiduciary-selection__container">
    <mds-loader v-if="loading" />
    <template v-else-if="hasRelatedFiduciaries">
      <template v-if="selectFiduciary">
        <h2>Your Fiduciaries</h2>
        <p>Select the Fiduciary that you want to work with.</p>
        <ul class="mds-list-group">
          <li v-for="fiduciary in fiduciaries" :key="fiduciary.id" class="mds-list-group__item">
            <mds-button
              variation="flat"
              size="medium"
              class="mds-list-group__button-links"
              @click="setFiduciary(fiduciary)"
            >
              {{ fiduciary.fiduciaryName }}
            </mds-button>
          </li>
        </ul>
      </template>
    </template>
    <template v-else>
      <h2>No Assigned Fiduciary</h2>
      <p>You need to have at least an assigned fiduciary to continue</p>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { goToRoute } from '@/utils';
import { login as loginMessage } from '@/config/auth-messages.json';
import { MdsButton } from '@mds/button';
import { requestToValidateUserAuthentication } from '@/services/Login';

export default {
  name: 'fiduciary-selection',
  components: {
    MdsButton,
  },
  data() {
    return {
      loading: false,
      selectFiduciary: false,
    };
  },
  async created() {
    this.loading = true;
    let errorMessage = null;
    try {
      const result = await requestToValidateUserAuthentication();
      this.loading = false;
      const { userRole = [], fiduciaries = [] } = result;

      // Extract the first role from the roles array
      const [firstRole = ''] = userRole;

      if (this.isValidFiduciaryList(fiduciaries)) {
        if (this.hasMultipleFiduciaries(fiduciaries)) {
          // If the user has multiple fiduciaries should be able to select its fiduciary
          this.selectFiduciary = true;
        } else {
          // If the user only have one fiduciary that fiduciary will be assigned to him directly
          this.selectFiduciary = false;
          const [fiduciary = {}] = fiduciaries;
          this.setFiduciary(fiduciary);
        }
      } else {
        errorMessage = loginMessage.error.missingAssignedFiduciary;
        this.openNotification({
          notificationType: 'error',
          title: 'No Assigned Fiduciary',
          message: errorMessage,
        });
      }

      // Store user info
      this.$store.dispatch('setUserInfo', {
        userRole: firstRole,
        fiduciaries,
      });
    } catch (error) {
      const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
      this.loading = false;
      if (httpStatus === 401) {
        this.$router.push('/Login');
      }
    }
  },
  computed: {
    ...mapState({
      fiduciaries: (state) => state.user.fiduciaries,
    }),
    hasRelatedFiduciaries() {
      return Array.isArray(this.fiduciaries) && this.fiduciaries.length > 0;
    },
  },
  methods: {
    ...mapActions({
      setUserInfo: 'setUserInfo',
      openNotification: 'openNotification',
    }),
    setFiduciary(fiduciary) {
      const { fiduciaryCode = '', id = 0 } = fiduciary;

      this.$store.dispatch('setFiduciary', fiduciary);
      this.$store.dispatch('setConfig', fiduciaryCode);

      // isPreferredColumn Config
      const newConfig = {
        grid: {
          columns: {
            preferred: fiduciary.isPreferredColumnActive || false,
          },
        },
      };
      this.$store.dispatch('overrideConfig', newConfig);

      if (id && fiduciaryCode) {
        goToRoute(this.$route, this.$router, '/');
      }
    },
    isValidFiduciaryList(fiduciaries) {
      return Array.isArray(fiduciaries) && fiduciaries.length > 0;
    },
    hasMultipleFiduciaries(fiduciaries) {
      return Array.isArray(fiduciaries) && fiduciaries.length > 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.mds-list-group {
  &__button-links {
    color: $mds-background-color-dark-gray;
    &:hover, &:focus {
      color: $mds-interactive-color-primary-hover;
    }
  }
}
</style>
